var render = function render(){var _vm=this,_c=_vm._self._c;return _c('event-drawer',{attrs:{"id":"CachedImageEventList","resId":_vm.resId,"getParams":_vm.getParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }